/* tslint:disable */
export const messages = {
  fr: {
    global: {
      pointOfInterest: 'point d\'intérêt | points d\'intérêt',
      collection: 'collection | collections',
      person: 'personne | personnes',
      enlargeImage: 'Agrandir l\'image',
      forFurther: 'En savoir plus',
      contentNotAvailableInYourLanguage: 'Ce contenu n\'est pas disponible pour votre langue',
      startAudioGuide: 'Lancer l\'audioguide',
      audioguidePoiNotCurrentPoi: 'Attention, l\'audioguide ne correspond pas au point d\'intérêt actuel.',
      audioguideTrackEndWithNextTrackTitle: 'Fin de la piste d\'audioguide',
      audioguideTrackEndWithNextTrackDescription: 'Voulez-vous lancer la piste suivante ?',
      audioguideTrackEndWithNextTrackButton: 'Lancer la piste suivante',
      audioguideTrackEndWithNextTrackAutoNext: 'lancement automatique de la piste suivante dans :',
      yes: 'Oui',
      no: 'Non',
      noQrCodeNum: 'Le numéro ne semble pas valide',
      scanQrCode: 'Scanner un QR-Code',
      scanQrCodeNotAllowedTitle: 'Accès à la caméra refusé',
      scanQrCodeNotAllowedSummary: 'Nous ne pouvons accèder à votre caméra… Vous pouvez néanmoins rechercher un contenu sur la page recherche !',
      scanQrCodeNotFoundTitle: 'Caméra introuvable !',
      scanQrCodeNotFoundSummary: 'Votre équipement ne semble pas être équipé d\'une caméra… Vous pouvez néanmoins rechercher un contenu dans la page recherche',
      setQrCodeNum: 'Page recherche',
      scanQrCodeSearchPage: 'Page recherche',
      scanQrCodeWarning: 'Ce QR-Code n\'est pas reconnu... Vous pouvez aussi rechercher un contenu via la page recherche.',
      next: 'Suivant',
      prev: 'Précédent',
      send: 'Envoyer',
      play: 'Jouer',
      close: 'Fermer',
      puzzleEnded: 'Puzzle terminé 👍',
      playAgain: 'Rejouer',
      movement: 'Déplacements',
      duration: 'Temps',
      setAudioguideContent: 'Jouer l\'audioguide correspondant au contenu',
      ignore: 'Ignorer',
      loading: 'Chargement…'
    }
  },
  en: {
    global: {
      pointOfInterest: 'point of interest | points of interest',
      collection: 'collection | collections',
      person: 'person | people',
      enlargeImage: 'Enlarge image',
      forFurther: 'Read more',
      contentNotAvailableInYourLanguage: 'This content is not available for your language',
      startAudioGuide: 'Start audioguide',
      audioguidePoiNotCurrentPoi: 'Warning, the audioguide doesn\'t match the current content.',
      audioguideTrackEndWithNextTrackTitle: 'End of the track',
      audioguideTrackEndWithNextTrackDescription: 'Do you want to play the next track ?',
      audioguideTrackEndWithNextTrackButton: 'Play the next track',
      audioguideTrackEndWithNextTrackAutoNext: 'Auto next track in :',
      yes: 'Yes',
      no: 'No',
      noQrCodeNum: 'The number does not seem valid',
      scanQrCode: 'Scan a QRCode',
      scanQrCodeNotAllowedTitle: 'Accès à la caméra refusé',
      scanQrCodeNotAllowedSummary: 'Nous ne pouvons accèder à votre caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      scanQrCodeNotFoundTitle: 'Caméra introuvable !',
      scanQrCodeNotFoundSummary: 'Votre équipement ne semble pas être équipé d\'une caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      setQrCodeNum: 'Enter a number',
      next: 'Next',
      prev: 'Previous',
      send: 'Send',
      play: 'Play',
      close: 'Close',
      puzzleEnded: 'Puzzle completed 👍',
      playAgain: 'Play Again',
      movement: 'Movements',
      duration: 'Duration',
      setAudioguideContent: 'Play the corresponding audio track',
      ignore: 'Ignore',
      loading: 'Loading...'
    }
  },
  us: {
    global: {
      pointOfInterest: 'point of interest | points of interest',
      collection: 'collection | collections',
      person: 'person | people',
      enlargeImage: 'Enlarge image',
      forFurther: 'Read more',
      contentNotAvailableInYourLanguage: 'This content is not available for your language',
      startAudioGuide: 'Start audioguide',
      audioguidePoiNotCurrentPoi: 'Warning, the audioguide doesn\'t match the current content.',
      audioguideTrackEndWithNextTrackTitle: 'End of the track',
      audioguideTrackEndWithNextTrackDescription: 'Do you want to play the next track ?',
      audioguideTrackEndWithNextTrackButton: 'Play the next track',
      audioguideTrackEndWithNextTrackAutoNext: 'Auto next track in :',
      yes: 'Yes',
      no: 'No',
      noQrCodeNum: 'The number does not seem valid',
      scanQrCode: 'Scan a QRCode',
      scanQrCodeNotAllowedTitle: 'Accès à la caméra refusé',
      scanQrCodeNotAllowedSummary: 'Nous ne pouvons accèder à votre caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      scanQrCodeNotFoundTitle: 'Caméra introuvable !',
      scanQrCodeNotFoundSummary: 'Votre équipement ne semble pas être équipé d\'une caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      setQrCodeNum: 'Enter a number',
      next: 'Next',
      prev: 'Previous',
      send: 'Send',
      play: 'Play',
      puzzleEnded: 'Puzzle completed 👍',
      movement: 'Movements',
      duration: 'Duration',
      setAudioguideContent: 'Play the corresponding audio track',
      ignore: 'Ignore',
      loading: 'Loading...'
    }
  },
  da: {
    global: {
      pointOfInterest: 'interessepunkt | interessepunkter',
      collection: 'samling | samlinger', 
      person: 'person | personer',
      enlargeImage: 'Forstør billede',
      forFurther: 'Læs mere',
      contentNotAvailableInYourLanguage: 'Dette indhold er ikke tilgængeligt på dit sprog',
      startAudioGuide: 'Start lydguide',
      audioguidePoiNotCurrentPoi: 'Advarsel, lydguiden matcher ikke det aktuelle indhold.',
      audioguideTrackEndWithNextTrackTitle: 'Slutningen af sporet',
      audioguideTrackEndWithNextTrackDescription: 'Vil du afspille det næste spor?',
      audioguideTrackEndWithNextTrackButton: 'Afspil næste spor',
      audioguideTrackEndWithNextTrackAutoNext: 'Automatisk næste spor om:',
      yes: 'Ja',
      no: 'Nej',
      noQrCodeNum: 'Nummeret ser ikke ud til at være gyldigt',
      scanQrCode: 'Scan en QR-kode',
      scanQrCodeNotAllowedTitle: 'Kameraadgang nægtet',
      scanQrCodeNotAllowedSummary: 'Vi kan ikke få adgang til dit kamera... Du kan dog indtaste nummeret fra QR-koden manuelt',
      scanQrCodeNotFoundTitle: 'Kamera ikke fundet!',
      scanQrCodeNotFoundSummary: 'Dit udstyr ser ikke ud til at have et kamera... Du kan dog indtaste nummeret fra QR-koden manuelt',
      setQrCodeNum: 'Indtast et nummer',
      next: 'Næste',
      prev: 'Forrige',
      send: 'Send',
      play: 'Afspil',
      close: 'Luk',
      playAgain: 'Spil igen',
      puzzleEnded: 'Puslespil fuldført 👍',
      movement: 'Bevægelser',
      duration: 'Varighed',
      setAudioguideContent: 'Afspil det tilsvarende lydspor',
      ignore: 'Ignorer',
      loading: 'Indlæser...'
    }
  },
  es: {
    global: {
      pointOfInterest: 'point of interest | points of interest',
      collection: 'collection | collections',
      person: 'person | people',
      enlargeImage: 'Ampliar la imagen',
      forFurther: 'Leer más',
      contentNotAvailableInYourLanguage: 'Este contenido no está disponible para su idioma',
      startAudioGuide: 'iniciar la audioguía',
      audioguidePoiNotCurrentPoi: 'Advertencia, la audioguía no coincide con el contenido actual',
      audioguideTrackEndWithNextTrackTitle: 'Fin de la pista',
      audioguideTrackEndWithNextTrackDescription: '¿Quieres lanzar la pista siguiente?',
      audioguideTrackEndWithNextTrackButton: 'Lanzar la pista siguiente',
      audioguideTrackEndWithNextTrackAutoNext: 'Auto next track in :',
      yes: 'Yes',
      no: 'No',
      noQrCodeNum: 'El número no parece válido',
      scanQrCode: 'Escanear un QRCode',
      scanQrCodeNotAllowedTitle: 'Accès à la caméra refusé',
      scanQrCodeNotAllowedSummary: 'Nous ne pouvons accèder à votre caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      scanQrCodeNotFoundTitle: '¡Cámara no encontrada!',
      scanQrCodeNotFoundSummary: 'Votre équipement ne semble pas être équipé d\'une caméra… Vous pouvez néanmoins saisir manuellement le numéro présent sur le QrCode',
      setQrCodeNum: 'Introduzca un número',
      next: 'Siguiente',
      prev: 'Anteriormente',
      send: 'Enviar',
      play: 'Reproducir',
      close: 'Close',
      playAgain: 'Play Again',
      puzzleEnded: 'Puzzle completed 👍',
      movement: 'Movements',
      duration: 'Duration',
      setAudioguideContent: 'Reproducir la pista de audio correspondiente',
      ignore: 'Ignore',
      loading: 'Cargando...'
    }
  },
  nl: {
    global: {
      pointOfInterest: 'interessepunt | interessepunten',
      collection: 'collectie | collecties', 
      person: 'persoon | personen',
      enlargeImage: 'Afbeelding vergroten',
      forFurther: 'Lees meer',
      contentNotAvailableInYourLanguage: 'Deze inhoud is niet beschikbaar in uw taal',
      startAudioGuide: 'Start audiogids',
      audioguidePoiNotCurrentPoi: 'Waarschuwing, de audiogids komt niet overeen met de huidige inhoud.',
      audioguideTrackEndWithNextTrackTitle: 'Einde van de track',
      audioguideTrackEndWithNextTrackDescription: 'Wilt u de volgende track afspelen?',
      audioguideTrackEndWithNextTrackButton: 'Speel de volgende track af',
      audioguideTrackEndWithNextTrackAutoNext: 'Automatisch volgende track in:',
      yes: 'Ja',
      no: 'Nee',
      noQrCodeNum: 'Het nummer lijkt niet geldig',
      scanQrCode: 'Scan een QR-code',
      scanQrCodeNotAllowedTitle: 'Geen toegang tot camera',
      scanQrCodeNotAllowedSummary: 'We kunnen geen toegang krijgen tot uw camera... U kunt het nummer op de QR-code wel handmatig invoeren',
      scanQrCodeNotFoundTitle: 'Camera niet gevonden!',
      scanQrCodeNotFoundSummary: 'Uw apparaat lijkt geen camera te hebben... U kunt het nummer op de QR-code wel handmatig invoeren',
      setQrCodeNum: 'Voer een nummer in',
      next: 'Volgende',
      prev: 'Vorige',
      send: 'Verzenden',
      play: 'Afspelen',
      close: 'Sluiten',
      playAgain: 'Opnieuw spelen',
      puzzleEnded: 'Puzzel voltooid 👍',
      movement: 'Bewegingen',
      duration: 'Duur',
      setAudioguideContent: 'Speel de bijbehorende audiotrack af',
      ignore: 'Negeren',
      loading: 'Laden...'
    }
  },
  de: {
    global: {
      pointOfInterest: 'Sehenswürdigkeit | Sehenswürdigkeiten',
      collection: 'Sammlung | Sammlungen',
      person: 'Person | Personen',
      enlargeImage: 'Bild vergrößern',
      forFurther: 'Weiterlesen',
      contentNotAvailableInYourLanguage: 'Dieser Inhalt ist in Ihrer Sprache nicht verfügbar',
      startAudioGuide: 'Audioguide starten',
      audioguidePoiNotCurrentPoi: 'Achtung, der Audioguide stimmt nicht mit dem aktuellen Inhalt überein.',
      audioguideTrackEndWithNextTrackTitle: 'Ende des Tracks',
      audioguideTrackEndWithNextTrackDescription: 'Möchten Sie den nächsten Track abspielen?',
      audioguideTrackEndWithNextTrackButton: 'Nächsten Track abspielen',
      audioguideTrackEndWithNextTrackAutoNext: 'Automatisch nächster Track in:',
      yes: 'Ja',
      no: 'Nein', 
      noQrCodeNum: 'Die Nummer scheint ungültig zu sein',
      scanQrCode: 'QR-Code scannen',
      scanQrCodeNotAllowedTitle: 'Kamerazugriff verweigert',
      scanQrCodeNotAllowedSummary: 'Wir können nicht auf Ihre Kamera zugreifen... Sie können die Nummer auf dem QR-Code jedoch manuell eingeben',
      scanQrCodeNotFoundTitle: 'Kamera nicht gefunden!',
      scanQrCodeNotFoundSummary: 'Ihr Gerät scheint keine Kamera zu haben... Sie können die Nummer auf dem QR-Code jedoch manuell eingeben',
      setQrCodeNum: 'Nummer eingeben',
      next: 'Weiter',
      prev: 'Zurück',
      send: 'Senden',
      play: 'Abspielen',
      close: 'Schließen',
      playAgain: 'Erneut abspielen',
      puzzleEnded: 'Puzzle abgeschlossen 👍',
      movement: 'Bewegungen',
      duration: 'Dauer',
      setAudioguideContent: 'Zugehörige Audiospur abspielen',
      ignore: 'Ignorieren',
      loading: 'Laden...'
    }
  },
  it: {
    global: {
      pointOfInterest: 'point of interest | points of interest',
      collection: 'collection | collections',
      person: 'person | people',
      enlargeImage: 'ingrandire l\'immagine',
      forFurther: 'Leggi di più',
      contentNotAvailableInYourLanguage: 'Questo contenuto non è disponibile per la tua lingua',
      startAudioGuide: 'Avviare l\'audioguida',
      audioguidePoiNotCurrentPoi: 'Attenzione, l\'audioguida non corrisponde al contenuto attuale.',
      audioguideTrackEndWithNextTrackTitle: 'Fine della pista',
      audioguideTrackEndWithNextTrackDescription: 'Vuoi lanciare la pista successiva?',
      audioguideTrackEndWithNextTrackButton: 'Lancia la pista successiva',
      audioguideTrackEndWithNextTrackAutoNext: 'Auto next track in :',
      yes: 'Yes',
      no: 'No',
      noQrCodeNum: 'Il numero non sembra valido',
      scanQrCode: 'Scansione di un QRCode',
      scanQrCodeNotAllowedTitle: 'Accesso alla telecamera negato',
      scanQrCodeNotAllowedSummary: 'Non possiamo accedere alla tua telecamera... Puoi ancora inserire il numero sul QrCode manualmente',
      scanQrCodeNotFoundTitle: 'telecamera non trovata!',
      scanQrCodeNotFoundSummary: 'Il tuo apparecchio non sembra essere dotato di una telecamera... Puoi comunque inserire manualmente il numero sul QrCode',
      setQrCodeNum: 'Inserire un numero',
      next: 'Prossimo',
      prev: 'Precedente',
      send: 'Inviare',
      play: 'Riprodurre',
      close: 'Close',
      puzzleEnded: 'Puzzle completed 👍',
      playAgain: 'Play Again',
      movement: 'Movements',
      duration: 'Duration',
      setAudioguideContent: 'Riprodurre la traccia audio corrispondente',
      ignore: 'Ignorare',
      loading: 'Caricamento...'
    }
  },
  pt: {
    global: {
      pointOfInterest: 'ponto de interesse | pontos de interesse',
      collection: 'coleção | coleções',
      person: 'pessoa | pessoas',
      enlargeImage: 'Ampliar imagem',
      forFurther: 'Ler mais',
      contentNotAvailableInYourLanguage: 'Este conteúdo não está disponível no seu idioma',
      startAudioGuide: 'Iniciar audioguia',
      audioguidePoiNotCurrentPoi: 'Atenção, o audioguia não corresponde ao conteúdo atual.',
      audioguideTrackEndWithNextTrackTitle: 'Fim da faixa',
      audioguideTrackEndWithNextTrackDescription: 'Deseja reproduzir a próxima faixa?',
      audioguideTrackEndWithNextTrackButton: 'Reproduzir a próxima faixa',
      audioguideTrackEndWithNextTrackAutoNext: 'Próxima faixa automática em:',
      yes: 'Sim',
      no: 'Não',
      noQrCodeNum: 'O número não parece válido',
      scanQrCode: 'Digitalizar um QRCode',
      scanQrCodeNotAllowedTitle: 'Acesso à câmera negado',
      scanQrCodeNotAllowedSummary: 'Não podemos acessar sua câmera... Você ainda pode inserir manualmente o número no QrCode',
      scanQrCodeNotFoundTitle: 'Câmera não encontrada!',
      scanQrCodeNotFoundSummary: 'Seu dispositivo parece não ter câmera... Você ainda pode inserir manualmente o número no QrCode',
      setQrCodeNum: 'Digite um número',
      next: 'Próximo',
      prev: 'Anterior',
      send: 'Enviar',
      play: 'Reproduzir',
      close: 'Fechar',
      playAgain: 'Jogar Novamente',
      puzzleEnded: 'Quebra-cabeça completado 👍',
      movement: 'Movimentos',
      duration: 'Duração',
      setAudioguideContent: 'Reproduzir a faixa de áudio correspondente',
      ignore: 'Ignorar',
      loading: 'Carregando...'
    }
  },
  zh: {
    global: {
      pointOfInterest: '景点 | 景点',
      collection: '收藏 | 收藏',
      person: '人物 | 人物',
      enlargeImage: '放大图片',
      forFurther: '阅读更多',
      contentNotAvailableInYourLanguage: '该内容暂无您所选语言版本',
      startAudioGuide: '开始语音导览',
      audioguidePoiNotCurrentPoi: '警告：语音导览与当前内容不匹配。',
      audioguideTrackEndWithNextTrackTitle: '音轨结束',
      audioguideTrackEndWithNextTrackDescription: '是否播放下一个音轨？',
      audioguideTrackEndWithNextTrackButton: '播放下一个音轨',
      audioguideTrackEndWithNextTrackAutoNext: '自动播放下一个音轨：',
      yes: '是',
      no: '否',
      noQrCodeNum: '号码似乎无效',
      scanQrCode: '扫描二维码',
      scanQrCodeNotAllowedTitle: '相机访问被拒绝',
      scanQrCodeNotAllowedSummary: '我们无法访问您的相机...您仍可以手动输入二维码上的号码',
      scanQrCodeNotFoundTitle: '找不到相机！',
      scanQrCodeNotFoundSummary: '您的设备似乎没有相机...您仍可以手动输入二维码上的号码',
      setQrCodeNum: '输入号码',
      next: '下一个',
      prev: '上一个',
      send: '发送',
      play: '播放',
      close: '关闭',
      puzzleEnded: '拼图完成 👍',
      playAgain: '再玩一次',
      movement: '移动次数',
      duration: '持续时间',
      setAudioguideContent: '播放相应的音频轨道',
      ignore: '忽略',
      loading: '加载中...'
    }
  }
}
